import { render, staticRenderFns } from "./TaxDetailsStep.vue?vue&type=template&id=dcbc9084&"
import script from "./TaxDetailsStep.vue?vue&type=script&lang=js&"
export * from "./TaxDetailsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports